import { render, staticRenderFns } from "./CardScanConfirmDialog.vue?vue&type=template&id=20a56c8e&scoped=true&"
import script from "./CardScanConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./CardScanConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./CardScanConfirmDialog.vue?vue&type=style&index=0&id=20a56c8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a56c8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardText,VDialog})
